/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text, useColorModeValue } from "@chakra-ui/react";

export default function Footer(props) {
  const textColor = useColorModeValue("slate.500", "slate.400");
  const linkHover = useColorModeValue("brand.600", "teal.300");

  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems="center"
      justifyContent="space-between"
      px="30px"
      py="20px"
      mt="auto"
    >
      <Text
        color={textColor}
        fontSize="sm"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "12px", xl: "0px" }}
      >
        &copy; {new Date().getFullYear()}{" "} Tunisian XP Database
      </Text>

    </Flex>
  );
}

